(function () {
  'use strict';

  angular
    .module('web2print')
    .directive('floatingFaq', floatingFaq);

  /* @ngInject */
  function floatingFaq ($translate, floatingFaqInitializer, FeatureToggleFactory) {
    const directive = {
      restrict: 'E',
      link: linkFn
    };

    return directive;

    function linkFn (scope, element) {

      const openHumanyListener = scope.$on('humany:openFloatingWidget', open);

      const language = $translate.proposedLanguage() || $translate.use() || 'en';
      const widgetName = web2print.env.humanyFloatingWidgetPrefix + language;

      floatingFaqInitializer.then(function () {
        Humany.Widgets.Coordinator.trigger(element, { widgetName: widgetName, activate: false });
      });


      scope.$on('$destroy', function () {
        window.Humany && Humany.ready && Humany.Widgets.Coordinator.destroy(widgetName);

        openHumanyListener();
      });

      function open () {
        Humany.Widgets.Coordinator.trigger(element, { widgetName: widgetName, activate: true });
      }
    }
  }
})();
